﻿/**
 * Pushes an analytics event to the Matomo dataLayer.
 * @param {Object} data - The event data to push to the dataLayer.
 */

export function analyticsEvent(data) {
    if (typeof dataLayer === 'object') {
        dataLayer.push(data);
    } else {
        console.log("dataLayer is not defined or not an object. Unable to push event data.")
    }
}